import { Plugin } from 'vue'
import { createGtag } from 'vue-gtag'

const plugin: Plugin = {
  install(app) {
    const id = import.meta.env.VITE_GTAG_ID
    if (!id) {
      console.warn('GTag ID is not provided')
      return
    }
    const gtag = createGtag({
      tagId: id,
    })
    app.use(gtag)
  },
}

export default plugin
